// Invite link already used? /findRecord now returns has_cognito_user (boolean) instead of the raw cognito_user_id; falls back to the old field so this works against either Lambda version.
export const isInviteRegistered = (record) => record?.has_cognito_user ?? (record?.cognito_user_id !== null);
